import React, { useEffect, useRef, forwardRef, useImperativeHandle } from "react";

export default forwardRef(function ({callback}, ref) {
  const turnstileRef = useRef(null);
  const widgetIdRef = useRef(null);

  useImperativeHandle(ref, () => ({
    reset: () => {
      if (window.turnstile && widgetIdRef.current !== null) {
        window.turnstile.reset(widgetIdRef.current);
      }
    }
  }));

  useEffect(() => {
    const loadTurnstile = () => {
      if (!window.turnstile || !turnstileRef.current) return;

      widgetIdRef.current = window.turnstile.render(turnstileRef.current, {
        callback,
        theme: "light",
      });
    };

    var _has_script = document.getElementById("cf-turnsite");

    if (!_has_script) {
      var script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
      script.async = true;
      script.onload = loadTurnstile;
      script.id = "cf-turnsite";
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div id="cf-turnsite-container" className="uk-margin-top">
      <div ref={turnstileRef} data-sitekey="0x4AAAAAABnKK2PYwXftELQ3"></div>
    </div>
  );
});
